<template>
  <BaseTooltip bottom>
    <template #activator="{on, attrs}">
      <span
        style="cursor:text" class="elements--text" v-bind="attrs"
        v-on="on">
        {{ text }}
      </span>
    </template>
    <span>{{ text }}</span>
  </BaseTooltip>
</template>

<script>
import utilityMethods from '@/mixin/AG/utilityMethods.js'

export default {
  name: 'BaseDisplayField',
  mixins: [utilityMethods],
  props: {
    feature: { type: Object, default () { return null } },
    featureLayer: { type: Object, default () { return null } },
    displayFields: { type: Array, default () { return [] } },
  },
  computed: {
    text () {
      let featureDisplayFieldText = ''
      if (!this.feature) {
        return featureDisplayFieldText
      }

      if (this.displayFields.length > 0) {
        const formattedAttributes = this.processFeatureResult(this.feature, this.featureLayer)
        for (const displayField of this.displayFields) {
          if (formattedAttributes[displayField]) {
            featureDisplayFieldText += `${formattedAttributes[displayField]}-`
          } else {
            featureDisplayFieldText += 'Null-'
          }
        }
        return featureDisplayFieldText.slice(0, -1)
      }
      return this.feature.attributes[this.featureLayer.displayField || this.featureLayer.objectIdField]
    },
  },

}
</script>

<style scoped>
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
